// extracted by mini-css-extract-plugin
export default {"showcaseContent":"showcase_showcaseContent__8JkGt","wrapper":"showcase_wrapper__KkmZ9","owner":"showcase_owner__ytxPk","row":"showcase_row__SOwUL"};